import * as React from 'react';
import { useState, useEffect, useContext } from "react";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PageHelper from '../../helper/pageHelper';
import { UserContext } from '../../App';
import { useTranslation } from "react-i18next";

interface passoprops {
    data: number;
}

export default function ForecastDiarioPassoAPasso(params: passoprops) {
    const { t } = useTranslation();
    // FLUXO TOTAL ['Definir Plano Base', 'Aprovar, Reprovar', 'Aprova, Congela ou Reprova', 'Lança produção', 'Aprova ou Reprova divergência', 'Integra Lançamento SAP', 'Monta proposta Entrega Produto Acabado', 'Confirma Entrega'];
    const steps = [
        t("pages.dailyForecast.text.defineBasePlan"), 
        t("pages.dailyForecast.text.approve"), 
        t("pages.dailyForecast.text.disapprove"), 
        t("pages.dailyForecast.text.itemsReleasedToLaunchProduction")
    ];

    const [activeStep, setActiveStep] = useState(params.data - 1);
    const [skipped, setSkipped] = useState(new Set<number>());

    const user: any = useContext(UserContext);

    useEffect(() => {
        if (params?.data) {
            setActiveStep(params.data - 1);
        }
    }, [params.data]);

    const isStepOptional = (step: number) => {
        return step === 500;
    };

    const isStepSkipped = (step: number) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
        let _step = activeStep + 2;
        _step = _step > 3 || _step < 0 ? _step = 1 : _step;
        window.location.href = PageHelper.urlClean() + "?step=" + String(_step);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        let _step = activeStep;
        _step = _step > 3 || _step < 0 ? _step = 1 : _step;
        window.location.href = PageHelper.urlClean() + "?step=" + String(_step);
    };

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <React.Fragment>
            <Typography component={'p'}>
                <br /><br />
                <Box sx={{ width: '98%', backgroundColor: "transparent" }}>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps: { completed?: boolean } = {};
                            const labelProps: {
                                optional?: React.ReactNode;
                            } = {};
                            if (isStepOptional(index)) {
                                labelProps.optional = (
                                    <Typography variant="caption">
                                        {t('pages.dailyForecast.text.optional')}
                                    </Typography>
                                );
                            }
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    {activeStep === steps.length ? (
                        <React.Fragment>
                            <Typography sx={{ mt: 2, mb: 1 }}>
                                {t("pages.dailyForecast.text.allStepsCompleted")}
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button size="small" onClick={handleReset}>{t('global.button.reset')}</Button>
                            </Box>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Typography variant="caption" sx={{ mt: 2, mb: 1 }}>{t('global.button.step')} {' '} {activeStep + 1}</Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Button
                                    color="inherit"
                                    disabled={activeStep === 0 || (!user.isRoot && !user.isSuporteBRF)}
                                    onClick={handleBack}
                                    sx={{ mr: 1 }}
                                    size="small">
                                    {t("common.back")}
                                </Button>
                                <Box sx={{ flex: '1 1 auto' }} />
                                {isStepOptional(activeStep) && (
                                    <Button size="small" color="inherit" onClick={handleSkip} sx={{ mr: 1 }} disabled>
                                        {t("common.skip")}
                                    </Button>
                                )}
                                <Button size="small" onClick={handleNext} disabled={!user.isRoot && !user.isSuporteBRF}>
                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                </Button>
                            </Box>
                        </React.Fragment>
                    )}
                </Box>
            </Typography>
        </React.Fragment>
    );
}
